import { replaceApexDomainForCurrentHost } from './connections/replace-apex-domain-for-current-host';

export const isLocalhost = window.location.hostname === 'localhost';

export const stageEnvironment = {
  isLocal: isLocalhost && import.meta.env.VITE_STAGE === 'dev',
  isDev: import.meta.env.VITE_STAGE === 'dev',
  isSandbox: import.meta.env.VITE_STAGE === 'sandbox',
  isQA: import.meta.env.VITE_STAGE === 'qa',
  isLoad: import.meta.env.VITE_STAGE === 'load',
  isStaging: import.meta.env.VITE_STAGE === 'staging',
  isProd: import.meta.env.VITE_STAGE === 'prod' || import.meta.env.VITE_STAGE === 'production',
};

export const getCreateProjectUrl = () => {
  return import.meta.env.VITE_PUBLIC_URL || '';
};

export function getBaseAdminURL(): string {
  if (stageEnvironment.isLocal) {
    return 'http://localhost:3000';
  }

  if (import.meta.env.VITE_EVENTS_APP_HOST) {
    return replaceApexDomainForCurrentHost(import.meta.env.VITE_EVENTS_APP_HOST);
  }

  return '';
}

export function getBaseEditorURL(): string {
  return getBaseAdminURL().replace('https://admin', 'https://editor');
}
